exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".preparation-main-category-page .btn-point-retrait[data-v-1c49c5b9], .preparation-main-category-page .btn-order[data-v-1c49c5b9] {\n  border: 2px solid #252525;\n  width: 100%;\n  margin: 0 auto;\n}\n@media (min-width: 768px) {\n.preparation-main-category-page .point-retrait .point-retrait-nom[data-v-1c49c5b9] {\n    border-right: 3px solid #252525;\n}\n}\n.preparation-main-category-page .point-retrait .point-retrait-nom .counter[data-v-1c49c5b9] {\n  text-align: center;\n  font-weight: bold;\n  font-size: 1rem;\n}\n.preparation-main-category-page .nothing[data-v-1c49c5b9] {\n  font-style: italic;\n  font-size: 1.3rem;\n}", ""]);

// exports
